var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m5.15152 5.15225c.46863-.46863 1.22843-.46863 1.69706 0l5.15142 5.15145 5.1515-5.15145c.4687-.46863 1.2284-.46863 1.6971 0 .4686.46863.4686 1.22843 0 1.69706l-5.1515 5.15149 5.1515 5.1515c.4686.4686.4686 1.2284 0 1.697-.4687.4686-1.2284.4686-1.6971 0l-5.1515-5.1515-5.15142 5.1515c-.46863.4686-1.22843.4686-1.69706 0s-.46863-1.2284 0-1.697l5.15148-5.1515-5.15148-5.15149c-.46863-.46863-.46863-1.22843 0-1.69706z",
    fill: "#4d586c",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.caf68120085f395188a5deb4e14186c6.svg";
export { ForwardRef as ReactComponent };